import { type ReactNode } from "react";
import { DisclaimerBar } from "./disclaimer-bar";
import { MarketingNav } from "./marketing-nav";
import { SiteFooter } from "./footer";

export function MarketingShell({ children }: { children: ReactNode }) {
  return (
    <div className="min-h-screen flex flex-col">
      <DisclaimerBar />
      <MarketingNav />
      <main className="flex-1">{children}</main>
      <SiteFooter />
    </div>
  );
}